/**
 * Текст ошибки для показа в форме — из чего угодно, что попало в catch.
 *
 * Ответ сервера приходит как WsError с data.message, но в тот же catch
 * попадает и исключение самого клиента. Приведение «(raw as WsError).data.message»
 * на нём падает, и вместо понятного сообщения человек видит нерабочую кнопку,
 * а настоящая причина теряется.
 */
export function errorMessage(raw: unknown, fallback = "Не удалось выполнить действие"): string {
  if (typeof raw === "object" && raw !== null && "data" in raw) {
    const data: unknown = raw.data;
    if (typeof data === "object" && data !== null && "message" in data) {
      const message: unknown = data.message;
      if (typeof message === "string" && message !== "") return message;
    }
  }
  if (raw instanceof Error && raw.message !== "") return raw.message;
  return fallback;
}
